(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentAgreementsModule', [
			'agreementsModule',
			'apiModule',
			'coreModule',
			'formValidationModule',
			'progressIndicatorModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);